import * as yup from 'yup';

import { makeAPaymentDataKeys } from './constants';

export const makeAPaymentSchema = yup.object().shape({
    [makeAPaymentDataKeys.firstName]: yup.string().required('First name is required'),
    [makeAPaymentDataKeys.lastName]: yup.string().required('Last name is required'),
    [makeAPaymentDataKeys.email]: yup.string().email().required('Email is required'),
    [makeAPaymentDataKeys.location]: yup.string().required('Location is required'),
    [makeAPaymentDataKeys.room]: yup.string().required('Room is required'),
    [makeAPaymentDataKeys.academicYear]: yup.string().required('Academic year is required'),
    [makeAPaymentDataKeys.amount]: yup.string().required('Amount is required'),
    [makeAPaymentDataKeys.vitaRef]: yup.string().required('VITAREF is required'),
});
